import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useParams } from 'react-router-dom';

import { microfrontendConfig } from '@/infrastructure/config/microfrontend.config';
import StudyPlan from '@/presentation/screens/study-plan';

import { ApplicationLayout } from '../layouts/application/application.layout';
import Library from '../screens/library';
import Quizzes from '../screens/quizzes';

const MicrofrontendRedirect = ({ externalPath }) => {
  const params = useParams();

  useEffect(() => {
    if (externalPath) {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const fullPath = `${baseUrl}${externalPath.replace(/:([\w]+)/g, (_, key) => params[key])}`;
      window.location.href = fullPath;
    }
  }, [params, externalPath]);

  return null;
};

export const Router: React.FC = () => {
  const basePath = microfrontendConfig.getBasePath();

  return (
    <BrowserRouter basename={basePath}>
      <Routes>
        <Route element={<ApplicationLayout />}>
          <Route path="/" element={<StudyPlan />} />
          <Route path="/library" element={<Library />} />
          <Route path="/practice" element={<Quizzes />} />
          <Route
            path="/exercises/exam/:guid"
            element={<MicrofrontendRedirect externalPath="/exercises/exam/:guid" />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
